import { render, staticRenderFns } from "./UserReferralInfoPage.vue?vue&type=template&id=707a210b&scoped=true&"
import script from "./UserReferralInfoPage.vue?vue&type=script&lang=ts&"
export * from "./UserReferralInfoPage.vue?vue&type=script&lang=ts&"
import style0 from "./UserReferralInfoPage.vue?vue&type=style&index=0&id=707a210b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a210b",
  null
  
)

export default component.exports